import {EtsyShop} from '@coolcolduk/etsy';
import {useEffect, useState} from 'react';
import getAxios from '../util/axios/getAxios';
import withFirebaseToken from '../util/firebase/withFirebaseToken';

/**
 * Fetch listings by shop using the Axios client.
 * @param token - token for our api
 * @param shopRecordId - etsy account id
 * @returns The listings response.
 */
export const fetchGetShopByOwnerUserId = async (token: string, shopRecordId: string): Promise<EtsyShop> => {
  const response = await getAxios('etsy', {token}).get<EtsyShop>(`getShopByOwnerUserId`, {
    params: {shopRecordId},
  });

  return response.data;
};

export const useGetShopByOwnerUserId = (shopRecordId?: string) => {
  const [data, setData] = useState<EtsyShop | undefined>(undefined);

  useEffect(() => {
    withFirebaseToken(async (token) => {
      if (!token || !shopRecordId) {
        setData(undefined);
        return;
      }
      setData(await fetchGetShopByOwnerUserId(token, shopRecordId));
    });
  }, [shopRecordId]);

  return data;
};
